import React, { Component } from 'react';
import MainHeader from '../../../components/common/MainHeader';
import FooterDesktop from '../../../components/common/FooterDesktop';
import Egypt_8N_9D_Tour_Package from '../../../components/package/Egypt/Egypt_8N_9D_Tour_Package';
import { Helmet } from 'react-helmet';
class Egypt_8N_9D_Page extends Component {
    constructor() {
        super();
        this.state = {
            ReviewersData: [],

        }
    }


    componentDidMount() {

        window.scroll(0, 0);
       
        const reviewersDataList = [
            {
                Name: "Dr.Anirban Roy and Family",
                ImageName: "Anirban-Roy.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Our family’s trip to Egypt with Team Adorable Vacation was nothing short of spectacular! Mr. Soumalya Ghosh made sure every aspect of our tour, from the majestic pyramids to the cruise on the Nile, was seamless and memorable. The kids were thrilled with the camel rides, and we were in awe of the ancient temples. His attention to detail and constant support made our experience truly special. Highly recommend Team Adorable for an unforgettable family vacation!",
            },
            {
                Name: "Mrs. Sumita Sen and Family",
                ImageName: "Sumita-Sen.webp",
                AllternateText: "...",
                Location: "@Mumbai",
                Comment: "We had the most amazing time in Egypt, thanks to the incredible planning and care by Mr. Akash Dutta from Adorable Vacation. From exploring the Sphinx to sailing the Nile, everything was perfectly arranged for our family. Mr. Akash’s professionalism and warm hospitality made us feel comfortable and well taken care of throughout the tour. Our Egypt adventure was magical, and we can’t wait to plan our next trip with them!",
            },
            {
                Name: "Mr. Rajesh Gupta and Family",
                ImageName: "Rajesh-Gupta.webp",
                AllternateText: "...",
                Location: "@Ahmedabad",
                Comment: "Exploring the wonders of Egypt with my family through Adorable Vacation was a dream come true. Mr. Soumalya Ghosh ensured that every moment was well-coordinated, from the breathtaking pyramids to the vibrant local markets. His expertise made our journey smooth and enjoyable, and the memories we’ve created are ones we will cherish forever. Thank you, Soumalya, for making our family trip so perfect!",
            },
            {
                Name: "Mrs. Pooja Mehta and Family",
                ImageName: "Pooja-Mehta.webp",
                AllternateText: "...",
                Location: "@Mumbai",
                Comment: "A big thank you to Mr. Akash Dutta and the entire team at Adorable Vacation for organizing an unforgettable family trip to Egypt! We were able to see all the iconic sites, including the Pyramids of Giza and the beautiful temples along the Nile. Akash made sure we were comfortable at every step, and his guidance throughout the tour was exceptional. It was a fantastic experience that we’ll talk about for years to come.",
            },
            {
                Name: "Mr. Shantanu Das and Family",
                ImageName: "Shantanu-Das.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Our family had a truly enriching and adventurous trip to Egypt with Adorable Vacation. Mr. Soumalya Ghosh was an outstanding tour coordinator, always ensuring our needs were met and providing insightful information about the historical sites. The tour was a perfect blend of excitement and relaxation, with everything taken care of so efficiently. We couldn’t have asked for a better experience. Thank you, Soumalya, for making this trip unforgettable!",
            },
        ];



        this.setState({
            ReviewersData: reviewersDataList
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Egypt Package Tour from Kolkata – Best Deal from Adorable Vacation LLP</title>
                    <meta name="description" content=" We Offer the Best Egypt Package Tour from Kolkata for 8N 9D. For Booking ☎ CALL Mr. SOUMALYA +91-98833-59713" />
                </Helmet>

                <MainHeader />

                <Egypt_8N_9D_Tour_Package
                    ReviewersData={this.state.ReviewersData}
                />

                <FooterDesktop />
            </>
        )
    }
}

export default Egypt_8N_9D_Page;